import Button from "../../../../components/Button/Button";
import { Section, Card } from "../Account/accountParts";
import { AUTH_OPTIONS, ENCRYPTION_OPTIONS, optionLabel } from "./smtpOptions";

const SmtpServerView = ({ smtp, onEdit, onReset }) => {
  const rows = smtp
    ? [
        ["Host", smtp.host],
        ["Port", smtp.port],
        ["Encryption", optionLabel(ENCRYPTION_OPTIONS, smtp.encryption)],
        ["Authentication", optionLabel(AUTH_OPTIONS, smtp.authentication)],
        ["Username", smtp.username],
        ["Password", "********"],
        ["From email", smtp.from_email],
      ]
    : [];

  return (
    <Section
      title="SMTP Settings"
      large
      actions={
        <>
          <Button size="sm" onClick={onEdit}>
            Update
          </Button>
          {smtp && (
            <Button size="sm" variant="secondary" onClick={onReset}>
              Reset to default SMTP
            </Button>
          )}
        </>
      }
    >
      <Card>
        {smtp ? (
          <div className="-mx-5 -my-5 overflow-x-auto">
            <table className="w-full min-w-[480px] table-auto border-collapse">
              <tbody>
                {rows.map(([label, value], index) => (
                  <tr key={label} className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}>
                    <td className="w-56 py-2.5 pl-5 pr-3 text-xs font-medium text-gray-900 whitespace-nowrap">
                      {label}
                    </td>
                    <td className="py-2.5 pl-3 pr-5 text-xs text-gray-700 break-all">{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-sm text-gray-600">
            System emails are sent through the default mail server. Click Update to send them
            through your own SMTP server instead.
          </p>
        )}
      </Card>
    </Section>
  );
};

export default SmtpServerView;